import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CommonState, error, isFetching } from '@pec/aion-ui-core/slices/common';
import { enqueueRequestErrorSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';

const name = 'businessShieldSSO';

export const fetchBusinessShieldSSOUrl = createAsyncThunk(
  `${name}/fetch`,
  async ({ userId, organizationId }: { userId: string; organizationId: string }, { dispatch }) => {
    try {
      const { data } = await axios.post<{ url: string }>(`/api/v1/products/addons/businessshield/sso`, {
        userId,
        organizationId
      });
      return data.url;
    } catch (error) {
      dispatch(enqueueRequestErrorSnackbar());
      throw error;
    }
  }
);

export type State = CommonState & {
  SSOUrl: string;
};

const initialState: State = {
  SSOUrl: '',
  isFetching: false,
  error: null
};

const businessShieldSSOUrl = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchBusinessShieldSSOUrl.pending, isFetching)
      .addCase(fetchBusinessShieldSSOUrl.fulfilled, (state, action) => {
        state.SSOUrl = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchBusinessShieldSSOUrl.rejected, error);
  }
});

export const { reducer: businessShieldSSOReducer } = businessShieldSSOUrl;
